import { CustomerFlowType } from '../../constants/customer-flow-type';
import { Application, CreateDraftAppErrors, CreateDraftAppInput } from '../../gql/graphql';
import { createForbiddenErrorMessage, createUnauthorizedErrorMessage } from '../../helpers/security/security';
import { nullifyLine2 } from '../../helpers/validators/address.helper';
import applicationFormService from '../../services/applicationForm.service';
import { NetworkError } from '../../state-machine/actions/genericActions';
import { identify } from '../../state-machine/actions/segment';
import { ApplyRequestMachineContext } from '../../state-machine/types/shared/context/applyMachineContext';
import { buildAnalytics } from '../../helpers/analytics/buildAnalytics';

export type CreateDraftAppResult = {
  application?: Application;
  customerFlowType?: CustomerFlowType;
  createDraftAppErrors?: CreateDraftAppErrors[];
  // resolverErrors: ResolverError[];
};
const createDraftApp = async (context: ApplyRequestMachineContext): Promise<CreateDraftAppResult> => {
  try {
    const createDraftAppInput: CreateDraftAppInput = {
      customer: {
        firstName: context.basicInfo?.firstName!,
        lastName: context.basicInfo?.lastName!,
        emailAddress: context.basicInfo?.emailAddress!,
        birthDate: context.basicInfoContinued?.birthDate!,
        cellPhone: context.cellPhone,
        accommodationAddress: nullifyLine2(context.accommodationAddress),
        billingAddress: nullifyLine2(context.billingAddress)!,
        shippingAddress: nullifyLine2(context.orderDetails?.customer?.shippingAddress) || undefined,
      },
      employment: {
        monthlyIncome: context.basicInfoContinued?.monthlyIncome!,
      },
      analytics: {
        ...buildAnalytics(),
        neuroIdIdentityId: context.shouldProcessNeuroId ? context.orderId : undefined,
        socureDeviceSessionId: context.socureDeviceSessionId ?? undefined,
      },
      orderId: context.orderId,
    };

    if (context.basicInfoContinued?.tokenizedTaxId) {
      createDraftAppInput.customer.tokenizedTaxpayerIdentificationNumber = context.basicInfoContinued?.tokenizedTaxId;
    } else if (context?.customers?.length) {
      createDraftAppInput.customer.tokenizedTaxpayerIdentificationNumber = context.customers[0].tokenizedTaxId;
    } else {
      createDraftAppInput.customer.taxpayerIdentificationNumber = context.basicInfoContinued?.taxpayerIdentificationNumber;
    }

    const response = await applicationFormService.createDraftApp(createDraftAppInput);

    var result = {
      application: { lease: { id: response?.data?.createDraftApp?.leaseApplicationId } },
      createDraftAppErrors: response?.data?.createDraftApp?.createDraftAppErrors,
    } as CreateDraftAppResult;

    if (!!response?.data?.createDraftApp?.leaseApplicationId) {
      result.customerFlowType = CustomerFlowType.VerifiedCustomer;
      if (context.shouldProcessNeuroId) nid('setRegisteredUserId', response?.data.createDraftApp?.customerId?.toString());
      identify(response?.data?.createDraftApp?.customerId!);
    }
    return result;
  } catch (err: any) {
    var error = {} as NetworkError;
    switch (err?.networkError?.statusCode) {
      case 403:
        error.forbiddenError = createForbiddenErrorMessage(err);
        break;
      case 401:
        error.unauthorizedError = createUnauthorizedErrorMessage(err);
        break;
      default:
        error.errorGeneral = err;
    }
    throw error;
  }
};

export default createDraftApp;
